import logoIcon from '../../img/logo.svg';
import logoOutIcon from '../../img/logout-icon.svg';
import "./Header.scss";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import asyncLogout from '../../store/thunks/auth/asyncLogout';

export default function Header() {
    const [isAuth, setIsAuth] = useState(false);
    const authStore = useSelector((store) => store.auth);
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(asyncLogout());
    }

    useEffect(() => {
        const {isAuth} = authStore;
        setIsAuth(isAuth);
    }, [authStore]);

    return (
        <header className="header">
            <div className="_container">
                <img className="logo-icon" src={logoIcon} alt="Водоканал" />
                { isAuth && <img className="logout-icon" src={logoOutIcon} alt="Водоканал" onClick={handleLogout}/> }
            </div>
        </header>
    );
}